// 2026-05-26 - FormuLearning - 인증 API 호출
// 파일 위치: frontend/src/api/auth.ts

import client from './client'
import type { ApiResponse } from '../types/api'
import type { LoginRequest, RegisterRequest, TokenResponse, User } from '../types/auth'

export async function login(body: LoginRequest): Promise<TokenResponse> {
  const { data } = await client.post<ApiResponse<TokenResponse>>('/auth/login', body)
  return data.data!
}

export async function register(body: RegisterRequest): Promise<User> {
  const { data } = await client.post<ApiResponse<User>>('/auth/register', body)
  return data.data!
}

export async function getMe(): Promise<User> {
  const { data } = await client.get<ApiResponse<User>>('/auth/me')
  return data.data!
}

export async function logout(): Promise<void> {
  await client.post('/auth/logout')
}
